import Rejoiner from '../../api/rejoiner';
import EmailValidator from '../../form-validators/email';
import PresenceValidator from '../../form-validators/presence';
import analytics from '../../analytics';
import BaseForm from '../form';

export const SELECTORS = {
  FORM: 'js-email-form'
};

export class BaseEmail extends BaseForm {
  constructor(form) {
    super();

    this.form = form;
    this.rejoiner = new Rejoiner();
    this.validators = [
      {
        field: 'email',
        validators: [EmailValidator, PresenceValidator],
        label: 'Email'
      }
    ];
  }

  handleSubmit = (e) => {
    e.preventDefault();

    const form = e.target;
    const isValid = this.validate(e, form);

    if (isValid) {
      this.processFormSubmission(form);
    }
  };

  processFormSubmission = (form) => {
    const formData = new FormData(form);
    const email = formData.get('email');

    this.onSubmitSuccess(email);
    this.redirectIfNeeded(form.dataset.redirectUrl);
  };

  redirectIfNeeded = (url) => {
    if (url) {
      window.location.href = url;
    }
  };

  subscribeToListParams = (email) => ({
    email,
    listId: this.form.dataset.value
  });

  onSubmitSuccess(email) {
    this.rejoiner.subscribeToList(this.subscribeToListParams(email));
    analytics.newsletterSubscribed({ email });
  }

  initialize = () => {
    this.form?.addEventListener('submit', this.handleSubmit);
  };
}
